import { REPORT_COLORS } from '../../constants';
import './SupplyBar.css';

export interface SupplySegment {
  label: string;
  mw: number;
  color: string;
}

/**
 * One bar, three segments: the simplest honest answer to "where does PEI's
 * electricity actually come from". Segments are separated by a surface-coloured
 * gap so adjacent fills never read as one block.
 */
export function SupplyBar({ segments }: { segments: SupplySegment[] }) {
  const total = segments.reduce((s, x) => s + x.mw, 0);

  return (
    <figure className="SupplyBar">
      <div className="SupplyBar-track" role="img"
           aria-label={segments.map((s) => `${s.label} ${((100 * s.mw) / total).toFixed(1)}%`).join(', ')}>
        {segments.filter((s) => s.mw > 0).map((s) => (
          <div
            key={s.label}
            className="SupplyBar-segment"
            style={{ width: `${(100 * s.mw) / total}%`, background: s.color }}
            title={`${s.label}: ${s.mw.toFixed(1)} MW (${((100 * s.mw) / total).toFixed(1)}%)`}
          />
        ))}
      </div>
      <ul className="SupplyBar-legend">
        {segments.map((s) => (
          <li key={s.label}>
            <span className="SupplyBar-swatch" style={{ background: s.color }} aria-hidden="true" />
            <span className="SupplyBar-label">{s.label}</span>
            <span className="SupplyBar-value">
              {((100 * s.mw) / total).toFixed(1)}%
              <span className="SupplyBar-mw"> · {s.mw.toFixed(1)} MW</span>
            </span>
          </li>
        ))}
      </ul>
    </figure>
  );
}

export const SUPPLY_COLORS = REPORT_COLORS;
